import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'clubiq_data_notice_accepted';

const DataNotice: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(localStorage.getItem(STORAGE_KEY) !== 'true');
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // ignore quota
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4">
      <div className="max-w-4xl mx-auto bg-slate-900 text-white rounded-2xl shadow-2xl p-4 md:p-5 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm md:text-base leading-relaxed flex-1">
          ClubIQ collects account and golf profile data to run the app. We use Supabase for login
          and storage, Vercel for hosting, and OpenAI for AI answers and optional club-photo
          identification.{' '}
          <Link to="/privacy" className="underline font-semibold text-green-300">
            Privacy Policy
          </Link>
        </p>
        <button
          type="button"
          onClick={accept}
          className="bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl px-5 py-2.5 whitespace-nowrap"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default DataNotice;
